import React, { useState, useEffect } from 'react';
import {
  fetchGlobalDictionary,
  updateGlobalDictionaryEntry,
  createGlobalDictionaryEntry,
  deleteGlobalDictionaryEntry,
} from '../../services/api';
import Loading from '../Loading';
import Error from '../Error';
import AdminTable from './AdminTable';

const GlobalDictionaryManager = () => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEntries = async () => {
    try {
      setLoading(true);
      const response = await fetchGlobalDictionary();
      setEntries(response.entries || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching global dictionary:', err);
      setError('Failed to load global dictionary');
      setEntries([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  const handleSave = async (id, data) => {
    await updateGlobalDictionaryEntry(id, data);
    setEntries((prev) => prev.map((e) => (e.id === id ? { ...e, ...data } : e)));
  };

  const handleCreate = async (data) => {
    const newEntry = await createGlobalDictionaryEntry(data);
    setEntries((prev) => [...prev, newEntry]);
  };

  const handleDelete = async (id) => {
    await deleteGlobalDictionaryEntry(id);
    setEntries((prev) => prev.filter((e) => e.id !== id));
  };

  const columns = [
    { key: 'id', header: 'ID', width: 60 },
    { key: 'english_word', header: 'English Word', editable: true, width: 180 },
    { key: 'czech_translation', header: 'Czech Translation', editable: true, width: 200 },
    { key: 'note', header: 'Note (důvod override)', editable: true, width: 260 },
    {
      key: 'updated_at',
      header: 'Updated',
      width: 100,
      render: (value) => (value ? new Date(value).toLocaleDateString() : '-'),
    },
  ];

  const editableFields = [
    { key: 'english_word', type: 'text', label: 'English Word', required: true },
    { key: 'czech_translation', type: 'text', label: 'Czech Translation', required: true },
    { key: 'note', type: 'textarea', label: 'Note (důvod override)', minHeight: '60px' },
  ];

  if (loading && entries.length === 0) {
    return <Loading />;
  }

  if (error && entries.length === 0) {
    return <Error message={error} />;
  }

  return (
    <AdminTable
      data={entries}
      columns={columns}
      onSave={handleSave}
      onCreate={handleCreate}
      onDelete={handleDelete}
      editableFields={editableFields}
      title="Globální slovník (DeepL override)"
      loading={loading}
      emptyMessage="No global dictionary entries found."
    />
  );
};

export default GlobalDictionaryManager;
